import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { VivaInputModule } from '../controls/viva-input/viva-input.module';
import { VivaSelectModule } from '../controls/viva-select/viva-select.module';
import { VivaToggleModule } from '../controls/viva-toggle/viva-toggle.module';
import { VivaDateInputModule } from '../controls/viva-date-input/viva-date-input.module';
import { VivaSpinnerModule } from '../controls/viva-spinner/viva-spinner.module';
import { VivaChatModule } from '../controls/viva-chat/viva-chat.module';
import { VivaInfoPopupModule } from '../controls/viva-info-popup/viva-info-popup.module';
import { VivaQuestionPopupModule } from '../controls/viva-question-popup/viva-question-popup.module';
import { VivaTextAreaModule } from '../controls/viva-text-area/viva-text-area.module';
import { VivaLineChartModule } from '../controls/viva-line-chart/viva-line-chart.module';
import { VivaErrorPopupModule } from '../controls/viva-error-popup/viva-error-popup.module';
import { VivaWarningPopupModule } from '../controls/viva-warning-popup/viva-warning-popup.module';
import { VivaPermissionPopupModule } from '../controls/viva-permission-popup/viva-permission-popup.module';
import { BiometricGuageModule } from '../controls/biometric-guage/biometric-guage.module';
import { HealthScoreGuageModule } from '../controls/health-score-guage/health-score-guage.module';
import { VivaScoreGuageModule } from '../controls/viva-score-guage/viva-score-guage.module';
import { WCEmotionModule } from '../controls/wc-emotion/wc-emotion.module';
import { NgApexchartsModule } from 'ng-apexcharts';

// Components without modules - declare them directly
import { VivaCalendarInputComponent } from '../controls/viva-calendar-input/viva-calendar-input.component';
import { VivaSliderModule } from '../controls/viva-slider/viva-slider.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    VivaInputModule,
    VivaToggleModule,
    VivaSelectModule,
    VivaDateInputModule,
    VivaSpinnerModule,
    VivaChatModule,
    VivaInfoPopupModule,
    VivaPermissionPopupModule,
    VivaQuestionPopupModule,
    VivaWarningPopupModule,
    VivaErrorPopupModule,
    VivaTextAreaModule,
    VivaLineChartModule,
    BiometricGuageModule,
    HealthScoreGuageModule,
    VivaScoreGuageModule,
    WCEmotionModule,
    NgApexchartsModule,
    VivaCalendarInputComponent,
    VivaSliderModule
  ],
  declarations: [],
  exports: [
    FormsModule,
    TranslateModule,
    VivaInputModule,
    VivaToggleModule,
    VivaSelectModule,
    VivaDateInputModule,
    VivaSpinnerModule,
    VivaChatModule,
    VivaInfoPopupModule,
    VivaPermissionPopupModule,
    VivaQuestionPopupModule,
    VivaWarningPopupModule,
    VivaErrorPopupModule,
    VivaTextAreaModule,
    VivaLineChartModule,
    BiometricGuageModule,
    HealthScoreGuageModule,
    VivaScoreGuageModule,
    WCEmotionModule,
    VivaCalendarInputComponent,
    VivaSliderModule
  ],
})
export class SharedModule {}

